import React from 'react'
import ReactDOM from 'react-dom'
import App from './components/App'
import './index.css'
import controller from './controller'
import { Container } from '@cerebral/react'

controller.getSignal('app.bootstrap')()

const renderApplication = (controller, component) =>
  ReactDOM.render(
    <Container controller={controller}>
      {React.createElement(component, null, null)}
    </Container>,
    document.getElementById('root')
  )

if (module.hot) {
  module.hot.accept('./components/App', () => {
    const NextApp = require('./components/App').default

    renderApplication(controller, NextApp)
  })
}

renderApplication(controller, App)



// WEBPACK FOOTER //
// ./src/index.js